
import { useCallback } from "react";
import { JobFormData } from "../types/jobTypes";

/**
 * Hook for handling form reset operations
 */
export const useJobFormReset = (
  setJobData: React.Dispatch<React.SetStateAction<JobFormData>>,
  jobDataRef: React.MutableRefObject<JobFormData>,
  setActiveTab: React.Dispatch<React.SetStateAction<string>>,
  setSelectedLanguages: React.Dispatch<React.SetStateAction<string[]>>,
  setShowOtherLanguageField: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const resetForm = useCallback(() => {
    //console.log("Resetting form state");
    setActiveTab("basic");
    const emptyForm: JobFormData = {
      title: "",
      companyId: "",
      companyName: "",
      description: "",
      aiSummary: "",
      skills: "",
      status: "open",
      employmentType: "",
      timeCommitment: "",
      contractDuration: "",
      startDate: "",
      endDate: "",
      seniorityLevel: "",
      budget: "",
      budgetFreelance: "",
      locationType: "",
      workplaceBreakdown: "",
      hardSkills: "",
      softSkills: "",
      educationLevel: "",
      yearsOfExperience: "",
      languageRequirements: "",
      extraLang: "",
      cultureTags: "",
      applicationDeadline: "",
      jobPostingDate: "",
      source: "",
      assignedRecruiter: "",
      employmentClassification: "",
      notes: ""
    };
    setJobData(emptyForm);
    jobDataRef.current = {...emptyForm};
    setSelectedLanguages([]);
    setShowOtherLanguageField(false);
  }, [setActiveTab, setJobData, jobDataRef, setSelectedLanguages, setShowOtherLanguageField]);

  return { resetForm };
};
